<template>
  <div class="seller-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">创建展厅</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="seller"
            :label-width="80">
        <FormItem label="名称"
                  label-position="top">
          <Input v-model="seller.name"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="封面图">
          <upload-thumb v-model="seller.thumb"
                        :ref="thumbRefList[0]"
                        :defaultList="thumblist[0]"
                        :autoCropWidth="300.18" :autoCropHeight="650"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*1624,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="描述"
                  label-position="top">
          <Input type="textarea"
                 v-model="seller.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="经度"
                  label-position="top">
          <Input v-model="seller.lng"
                 style="width:200px"></Input>&nbsp;&nbsp;
          <a href="https://lbs.amap.com/console/show/picker"
             target="_blank">拾取经纬度，大的是经度</a>
        </FormItem>
        <FormItem label="纬度"
                  label-position="top">
          <Input v-model="seller.lat"
                 style="width:200px"></Input>&nbsp;&nbsp;
          <a href="https://lbs.amap.com/console/show/picker"
             target="_blank">拾取经纬度，小的是纬度</a>
        </FormItem>
        <FormItem label="内容">
          <UEditor v-model="seller.content"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="管理用户名"
                  label-position="top">
          <Input v-model="seller.login_name"
                 :disabled="currentId>0"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="管理密码"
                  label-position="top"
                  v-if="this.currentId==0">
          <Input v-model="seller.login_pwd"
                 style="width:200px;"></Input>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editgoods()">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
export default {
  name: "seller-list",
  data () {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      exportLoading: false,
      //抽屉参数
      value3: false,
      isable: false,
      thumbRefList: [
        "zero",
        "one",
      ],
      thumblist: [[], []],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },

      seller: {},
      isClear: false,
      loading: true,
      dataloading: true,
      currentId: 0,
      title: "编辑",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 150
        },
        {
          title: "名称",
          key: "name",
          Width: 300,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '名称:' + params.row.name),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '哈希值:' + params.row.showroom_blockchain_id)
            ]);
          }
        },
        {
          title: "描述",
          key: "describe",
          tooltip: true
        },
        {
          title: '地址',
          key: 'diqu',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '经度:' + params.row.lng),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '纬度:' + params.row.lat)
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      status: 1
    };
  },
  created: function () {
    this.getTableList();
  },
  components: {
    UploadThumb,
    UEditor
  },
  watch: {},
  methods: {
    getTableList: function () {
      this.renderTable(1);
    },
    addGoodCate: function () {
      this.thumblist = [[], []];
      this.currentId = 0;
      this.seller = {};
      this.$refs["editContent"].message = "";

      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index) {
      this.thumblist = [[], []];
      this.showModalStatus = !this.showModalStatus;
      this.currentId = index;
      this.$api.showroom.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.seller = res.result;
          this.$refs["editContent"].message = res.result.content;
          this.pushThumbData([
            this.seller.thumb,
            this.seller.mask_thumb,
          ]);
          this.$Message.success(res.msg);
        } else {
          this.$Message.success(res.msg);
        }
      });
    },
    pushThumbData (list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != "") {
          console.log(this.thumblist);
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: "finished"
          });
        }
      }
    },
    // 修改
    editgoods (name) {
      if (this.$refs[this.thumbRefList[0]].uploadList.length > 0) {
        this.seller.thumb = this.$refs[
          this.thumbRefList[0]
        ].uploadList[0].url;
      }
      this.seller.content = this.$refs["editContent"].message;
      if (
        this.currentId == null ||
        this.currentId == 0 ||
        this.currentId == ""
      ) {
        this.$api.showroom.create(this.seller).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.getTableList();
          }
        });
      } else {
        this.$api.showroom.edit(this.seller).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = !this.showModalStatus;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.showroom.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      this.tablelist = [];
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.showroom.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
